import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { LOGIN, NOT_ACCESS, PRODUCTIVITY } from 'utils/routes';
import { SITE_ENGINEER } from 'utils/userRole';
import { useSelector } from 'react-redux';

interface PrivateRouteProps extends RouteProps {
  roleCheck?: string[];
}

function PrivateRoute(props: PrivateRouteProps): React.ReactElement {
  // @ts-ignore
  const user = useSelector((state) => state.user);

  if (!user.isAuthenticated) {
    return <Redirect to={{ pathname: LOGIN }} />;
  }

  if (props.roleCheck) {
    if (props.path === '/' && user.role === SITE_ENGINEER) {
      return <Redirect to={{ pathname: PRODUCTIVITY }} />;
    }

    if (!props.roleCheck.includes(user.role as string)) {
      return <Redirect to={{ pathname: NOT_ACCESS }} />;
    }
  }

  return <Route {...props} />;
}

export default PrivateRoute;
